// extracted by mini-css-extract-plugin
export default {"btn":"RightArrow_btn__awZ7Z","btnRight":"RightArrow_btnRight__xGaMI"};